import React, { useState } from 'react';
import styled from 'astroturf/react';

import $r from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import FeedbackOption from 'js/canonical_cards/work_card/modals/feedback_option';

interface Props {
  videoId: string;
}

const Container = styled.div`
  position: static;
  width: auto;
  max-width: 725px;
  padding: 32px 32px 16px 24px;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  background-color: #fff;
  color: #333;
  font-family: Georgia, serif;
`;

const Header = styled.div`
  overflow: hidden;
  max-height: 62px;
  font-size: 24px;
  line-height: 1.3em;
  max-height: none;
  margin-bottom: 12px;
  padding-left: 12px;
`;

const SubHeader = styled.div`
  color: #777;
  font-size: 13px;
  line-height: 20px;
  padding-left: 12px;
  font-weight: 400;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  padding-right: 24px;
  margin-top: 8px;
  margin-bottom: 12px;
`;

const Actions = styled.div`
  display: flex;
  margin-top: 8px;
  margin-right: -8px;
  justify-content: flex-end;
  align-items: center;
  font-family: Roboto, sans-serif;
`;

const CancelButton = styled.div`
  margin-right: 48px;
  color: #0954d3;
  cursor: pointer;
`;

const SubmitButton = styled.button`
  display: flex;
  height: 32px;
  padding-right: 16px;
  padding-left: 16px;
  justify-content: center;
  align-items: center;
  align-self: center;
  flex: 0 0 auto;
  border-radius: 16px;
  background-color: #0954d3;
  color: #fff;
  text-decoration: none;
  width: 110px;
  transition-property: all;
  transition-duration: 500ms;
  background-color: rgb(9, 84, 211);
  cursor: pointer;

  &:disabled {
    cursor: default;
    background-color: #777;
  }
`;

export default function VideoReportModal(props: Props) {
  const { videoId } = props;

  const [flags, setFlags] = useState<Array<string>>([]);

  const recordChoice = (flag: string) => {
    if (flags.includes(flag)) {
      setFlags(flags.filter((c) => c !== flag));
    } else {
      setFlags(flags.concat(flag));
    }
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'e' implicitly has an 'any' type.
  const onSubmit = (e) => {
    e.preventDefault();
    if (flags.length === 0) {
      return;
    }

    const route = $r.api_v0_video_flag_path({
      video_id: videoId,
      subdomain_param: 'api',
    });
    fetchWithCsrf(route, {
      method: 'POST',
      body: JSON.stringify({ flags: flags }),
      headers: { 'Content-Type': 'application/json' },
    });

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'modal' does not exist on type 'JQuery<HT... Remove this comment to see the full error message
    $('.modal').modal('hide');
    return;
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'e' implicitly has an 'any' type.
  const onCancel = (e) => {
    e.preventDefault();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'modal' does not exist on type 'JQuery<HT... Remove this comment to see the full error message
    $('.modal').modal('hide');
    return;
  };

  return (
    <Container>
      <Header>What's the problem with this video?</Header>
      <SubHeader>
        We use your feedback to show you, and other academics, only high quality
        videos.
      </SubHeader>
      <Body>
        <FeedbackOption
          onClick={() => recordChoice('spam')}
          iconName="fa-flag"
          color="red"
          text="It's inappropriate or spam"
          selected={flags.includes('spam')}
        />
        <FeedbackOption
          onClick={() => recordChoice('copyrighted_material')}
          iconName="fa-ban"
          color="brown"
          text="It's copyrighted material"
          selected={flags.includes('copyrighted_material')}
        />
        <FeedbackOption
          onClick={() => recordChoice('uploader_not_author')}
          iconName="fa-user-slash"
          color="yellow"
          text="The uploader is not the creator"
          selected={flags.includes('uploader_not_author')}
        />
        <FeedbackOption
          onClick={() => recordChoice('other')}
          iconName="fa-question"
          color="gray"
          text="Something else"
          selected={flags.includes('other')}
        />
      </Body>
      <Actions>
        <CancelButton onClick={onCancel}>Cancel</CancelButton>
        <SubmitButton onClick={onSubmit} disabled={flags.length === 0}>
          Submit
        </SubmitButton>
      </Actions>
    </Container>
  );
}
